import { FieldInputProps, FieldMetaProps, FormikProps, useField } from "formik";
import { Dispatch, FunctionComponent, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { ImagesRangeFormValues } from "@src/modules/shared/components/Results/ImagesRange/hooks/useImagesRange";
import {
  ImagesRangeFormWrapper,
  InputDescription,
  RangeValue,
} from "@src/modules/shared/components/Results/ImagesRange/ImagesRange.components";
import {
  ResultInput,
  ResultsButton,
  ResultsButtons,
} from "@src/modules/shared/components/Results/shared/components";
import { ReactComponent as Edit } from "@src/modules/shared/icons/edit.svg";

interface Props extends FormikProps<ImagesRangeFormValues> {
  isEdit: boolean;
  setIsEdit: Dispatch<SetStateAction<boolean>>;
  hasSelectedRange: boolean;
  maxValue: number;
}

const ImagesRangeForm: FunctionComponent<Props> = ({
  isEdit,
  setIsEdit,
  hasSelectedRange,
  maxValue,
}) => {
  const { t } = useTranslation();
  const [startField, startMeta] = useField("start");
  const [endField, endMeta] = useField("end");

  const getRangeInput = (
    field: FieldInputProps<number>,
    meta: FieldMetaProps<number>,
    placeholder: number,
  ) =>
    isEdit ? (
      <ResultInput
        {...field}
        value={field.value ?? ""}
        hasError={meta.touched && !!meta.error}
        placeholder={placeholder.toString()}
        min={1}
        max={maxValue}
      />
    ) : (
      <RangeValue>{field.value}</RangeValue>
    );

  return (
    <ImagesRangeFormWrapper>
      {(hasSelectedRange || isEdit) && (
        <>
          <InputDescription>{t("from")}</InputDescription>
          {getRangeInput(startField, startMeta, 1)}
          <InputDescription>{t("to")}</InputDescription>
          {getRangeInput(endField, endMeta, maxValue)}
        </>
      )}
      {isEdit ? (
        <ResultsButtons>
          <ResultsButton type="button" onClick={() => setIsEdit(false)}>
            {t("Cancel")}
          </ResultsButton>
          <ResultsButton type="submit" isSaveButton>
            {t("Save")}
          </ResultsButton>
        </ResultsButtons>
      ) : (
        <ResultsButton type="button" onClick={() => setIsEdit(true)}>
          <Edit />
          {t("Edit")}
        </ResultsButton>
      )}
    </ImagesRangeFormWrapper>
  );
};

export default ImagesRangeForm;
